import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
    ViewChild
} from '@angular/core';
import { ExtendedBaseTab } from '@common/classes/extended-base-tab';
import { CodelistDisplayModel } from '@common/models/common/CodelistDisplay.model';
import { TextAreaComponent } from '@progress/kendo-angular-inputs';
import { PcsDocumentAndApprovalServices } from '@services/pcs-document-and-approval-services.service';
import { CustomExtendedTabService } from 'app/singleton-services/custom-extended-tab.service';
import { IPcsDocumentOrApprovalDetailsDisplayModel } from '../../../../../vessel-visit/vessel-visit-list/models/PcdDocumentAndApprovalModels/DetailsDisplayModels/IPcsDocumentOrApprovalDetailsDisplayModel';
import { PcsDocumentAndApprovalRemarkDisplayModel } from '../../../../../vessel-visit/vessel-visit-list/models/PcdDocumentAndApprovalModels/DetailsDisplayModels/PcsDocumentAndApprovalRemarkDisplayModel';

@Component({
    selector: 'app-pcs-approval-tab-remarks',
    templateUrl: './pcs-approval-tab-remarks.component.html',
    styleUrls: ['./pcs-approval-tab-remarks.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PcsApprovalTabRemarksComponent extends ExtendedBaseTab implements OnInit, OnChanges {
    @Input() remarks: PcsDocumentAndApprovalRemarkDisplayModel[];
    @Input() pcsDocumentOrApprovalId = -1;
    @Input() isForApproval = true;
    @Input() currentDocumentStatus: CodelistDisplayModel;
    @Input() allowedInsertRemark = false;
    @Input() allowedRemark: boolean;
    @Input() isOnlyWatcher: boolean;
    @Output() newRemarkResponse: EventEmitter<IPcsDocumentOrApprovalDetailsDisplayModel> =
        new EventEmitter<IPcsDocumentOrApprovalDetailsDisplayModel>();
    @ViewChild('remarkTextArea') remarkTextArea: TextAreaComponent;

    openedRemarkForRemoval = -1;
    newRemarkDialogOpened = false;
    removeRemarkDialogOpened = false;

    constructor(
        customExtendedTabService: CustomExtendedTabService,
        private service: PcsDocumentAndApprovalServices
    ) {
        super(customExtendedTabService);
    }

    ngOnInit() {
        this.defaultPaging();
        this.loadItems(this.remarks);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes && changes.remarks && !changes.remarks.firstChange) {
            this.loadItems(this.remarks);
        }
    }

    public openNewRemarkDialog() {
        this.newRemarkDialogOpened = true;
    }

    public closeNewRemarksDialog() {
        this.newRemarkDialogOpened = false;
    }

    public submitNewRemark() {
        this.service
            .newRemark({
                isForApproval: this.isForApproval,
                pcsDocumentOrApprovalId: this.pcsDocumentOrApprovalId,
                remark: this.remarkTextArea.value
            })
            .subscribe((response) => {
                this.newRemarkResponse.emit(response);
                this.remarks = response.remarks;
                this.newRemarkDialogOpened = false;
                this.loadItems(this.remarks);
            });
    }

    public openRemoveRemarkDialog(id: number) {
        this.openedRemarkForRemoval = id;
        this.removeRemarkDialogOpened = true;
    }

    public closeRemoveRemarkDialog() {
        this.removeRemarkDialogOpened = false;
        this.openedRemarkForRemoval = -1;
    }

    public submitRemoveRemark() {
        this.service
            .removeRemark({
                isForApproval: this.isForApproval,
                pcsDocumentOrApprovalRemarkId: this.openedRemarkForRemoval
            })
            .subscribe((response) => {
                this.closeRemoveRemarkDialog();
                this.newRemarkResponse.emit(response);
                this.remarks = response.remarks;
                this.loadItems(this.remarks);
            });
    }
}
